/**
 * 计时器的时间间隔
 */
export const TIME_INTERVAL = 66;

/**
 * 备份长度
 */
export const HISTORY_LENGTH = 3;

/**
 * 识别多少次弹出 toast
 */
export const SCAN_FAIL_TOAST_COUNT = 5;

/**
 * 识别多少次弹出 popup
 */
export const SCAN_FAIL_POPUP_COUNT = 12;

/**
 * 事件
 */
export const EVENT = {
    /**
     * 设置 OCC token 完成
     */
    SET_OCC_TOKEN_SUCCESS: 'SET_TOKEN_SUCCESS',
}